export default [
  {
    name: "butterflyTexture",
    type: "texture",
    path: "textures/butterfly.png",
  },

  {
    name: "oceanTexture",
    type: "texture",
    path: `textures/oceanTextures.png`,
  },

  {
    name: "goggleModel",
    type: "glbModel",
    path: "goggle.glb",
  },
  // {
  //   name: "butterflyTexture2",
  //   type: "texture",
  //   path: "textures/butterfly2.png",
  // },
  // {
  //   name: "butterflyTexture3",
  //   type: "texture",
  //   path: "textures/butterfly3.png",
  // },
  // {
  //   name: "planeTexture",
  //   type: "texture",
  //   path: "textures/grey.png",
  // },
  // {
  //   name: "forestFloor",
  //   type: "glbModel",
  //   path: "forestbase.glb",
  // },
];
